import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "options-list texture-options side" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("li", { class: "subtitle hide-mobile" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("オプションの刺繍も選べます"),
    /*#__PURE__*/_createElementVNode("span", { class: "additional_fee" }, "追加費用5,500円")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("li", { class: "subtitle hide-desktop" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("追加費用"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("5500円")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormOption = _resolveComponent("FormOption")!
  const _component_FormScrollableTab = _resolveComponent("FormScrollableTab")!

  return (_openBlock(), _createBlock(_component_FormScrollableTab, {
    class: "side-content",
    index: _ctx.index,
    configName: _ctx.configName
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.slice(0, 6), (item) => {
          return (_openBlock(), _createBlock(_component_FormOption, {
            optionType: 'texture',
            key: item.id,
            option: item,
            onClick: ($event: any) => (_ctx.onClick(item)),
            isSelected: _ctx.config == item.id
          }, null, 8, ["option", "onClick", "isSelected"]))
        }), 128)),
        _hoisted_2,
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.slice(6, _ctx.options.length), (item) => {
          return (_openBlock(), _createBlock(_component_FormOption, {
            optionType: 'textureTextBottom',
            key: item.id,
            option: item,
            onClick: ($event: any) => (_ctx.onClick(item)),
            isSelected: _ctx.config == item.id
          }, null, 8, ["option", "onClick", "isSelected"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["index", "configName"]))
}